// ─── A quote that stopped (sprint 13, 5.5) ──────────────────────────────────
//
// For a delisted stock Finnhub keeps answering with its last trade: a price
// above zero and a timestamp from the day trading stopped. Taken as a live
// quote, that old price was counted in the portfolio's value and weights.
//
// The rule: a quote whose own timestamp is more than STALE_DAYS old is not a
// current price. The holding is treated like one with no quote (outside every
// total, named in the gaps) and the screen says since when: "אין ציטוט עדכני
// מאז DD/MM". Ten days is longer than any US market closure on record (four
// trading days, September 2001), so a long weekend never trips it.
import { dateNumeric } from "./formatDate";

export const STALE_DAYS = 10;

// Finnhub's `t` is in seconds.
export function isStaleQuote(t, now = Date.now()) {
  return Number.isFinite(t) && t > 0 && now / 1000 - t > STALE_DAYS * 86400;
}

// The line for a holding without a current quote. With the date of the last
// one when there is a last one; the year is added when it is not this year.
export function noQuoteText(holding, now = new Date()) {
  const t = holding?.lastQuoteAt;
  if (!(t > 0)) return "אין ציטוט עדכני";
  const d = new Date(t * 1000);
  const withYear = d.getFullYear() !== now.getFullYear();
  return `אין ציטוט עדכני מאז ${dateNumeric(d, { year: withYear })}`;
}
